import React from "react";

const Home = () => {
    return (
        <div>
            <a
                href="https://alternative.me/crypto/fear-and-greed-index/"
                target="_blank"
                rel="noreferrer"
            >
                <img
                    src="https://alternative.me/crypto/fear-and-greed-index.png"
                    alt="Latest Crypto Fear & Greed Index"
                    width="400px"
                />
            </a>
        </div>
    );
};

export default Home;
